import React from "react";
import { Table, Spinner, Alert } from "@themesberg/react-bootstrap";
import { checkStrEmpty } from "../redux/utils";
import { useResponsive } from "../hooks/useResponsive";

function CustomTable(props) {
  const {
    fields = [],
    data = [],
    isLoading = false,
    className = "",
    tableHeadStyle = {},
    headBackground = "#099019",
    headColor = "white",
    getRowStyle = f=>f
  } = props;

  const { isMobile } = useResponsive();

  return (
    <>
      <div className={isMobile ? "table-responsive" : ""}>
        <Table
          hover
          className={`user-table align-items-center ${className}`}
          style={{ 
            width: "100%",
            fontSize: isMobile ? '0.8rem' : '0.875rem'
          }}
          {...props}
          bordered
        >
          <thead className="table-header">
            <tr className="file-list-item">
              {fields.map((_item, _idx) => {
                 if (_item.hidden) {
                  return null;
                } else return (
                <th
                  key={_idx}
                  style={{
                    ...tableHeadStyle,
                    backgroundColor: headBackground,
                    color: headColor,
                    textAlign: "center",
                    fontSize: isMobile ? '0.75rem' : '0.875rem',
                    padding: isMobile ? '0.5rem 0.25rem' : '0.75rem',
                    whiteSpace: isMobile ? 'nowrap' : 'normal'
                  }}
                >
                  {_item.headerComponent ? _item.headerComponent()
                : _item.title}
                </th>
              )})}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={fields.length} className="text-center py-4">
                  <Spinner animation="border" variant="primary" />
                  {!isMobile && <p className="mt-2 mb-0 text-muted">Loading...</p>}
                </td>
              </tr>
            ) : (
              data.map((item, idx) => (
                <tr key={idx} style={getRowStyle(item)}>
                  {fields.map((_item, _idx) => {
                    let val = item[_item.value] || "";
                    let value_alt =
                      (_item.value_alt && item[_item.value_alt]) || "";
                    if (_item.component) {
                      return (
                        <td
                          key={_idx}
                          className={`${_item.className}`}
                          style={{
                            ...(typeof _item.style === "function"
                              ? _item.style(item)
                              : _item.style),
                            padding: isMobile ? '0.5rem 0.25rem' : '0.75rem',
                            fontSize: isMobile ? '0.75rem' : '0.875rem'
                          }}
                        >
                          {_item.component(item, idx)}
                        </td>
                      );
                    } else if (_item.hidden) {
                      return null;
                    } else {
                      return (
                        <td
                          key={_idx}
                          className={`${_item.className}`}
                          style={{
                            ...(typeof _item.style === "function"
                              ? _item.style(item)
                              : _item.style),
                            padding: isMobile ? '0.5rem 0.25rem' : '0.75rem',
                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                            whiteSpace: isMobile ? 'nowrap' : 'normal'
                          }}
                        >
                          {checkStrEmpty(val.toString())
                            ? value_alt
                            : val.toString()}
                        </td>
                      );
                    }
                  })}
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
      {data.length === 0 && !isLoading && (
        <Alert className="text-center">
          <i className="fas fa-info-circle me-2"></i>
          No record found.
        </Alert>
      )}
    </>
  );
}

export default CustomTable;
